import { createApp } from "vue";
import HikeMap from "./HikeMap.vue"
import store from "./store/store";
import { i18n } from '../../i18n';

if (document.querySelector('#hike-map')) {
  const app = createApp(HikeMap)
  app.use(store);
  app.use(i18n);
  app.mount('#hike-map');
}
